import {NavigationTab} from '@/logged/features/aside-menu';
import {useNotifications} from '@/logged/features/notifications';
import {I18nService} from '@malt/vue3-i18n';
import {computed} from 'vue';
import {useUser} from '../../user';

export function useHeaderNavigationTabs() {
    const notificationsStore = useNotifications();

    const userStore = useUser();

    const currentLanguage = computed(() => userStore.user?.currentLanguage);

    const messageEntry: NavigationTab = {
        id: 'Messages',
        title: I18nService.msg('navbar.header.tabs.messages.title'),
        url: {href: '/messages', heapId: 'navbar-tab__client-messages'},
        icons: {
            mainIcon: 'header/inbox',
        },
        notificationsCount: notificationsStore.notificationsRecord?.messages,
        // tooltip: I18nService.msg('navbar.header.tabs.messenger.title'),
        isActiveWhen: ({startWith}) => startWith('/messages'),
    };

    const urlHelpCenter = computed(() => userStore.hasSelectedClientIdentity ? '18214' : '18216');
    const identity = computed(() => userStore.hasSelectedClientIdentity ? 'client' : 'freelance');

    const headerNavigationTabs = computed((): NavigationTab[] => [
        ...(userStore.hasSelectedClientIdentity ? [messageEntry] : []),
        {
            id: 'HelpCenter',
            title: I18nService.msg('navbar.header.tabs.help.center.title'),
            icons: {
                mainIcon: 'header/help-center',
            },
            // tooltip: I18nService.msg('navbar.header.tabs.help.center.title'),
            url: {href: `https://help.malt.com/kb/${currentLanguage.value}/${urlHelpCenter.value}`, blank: true, heapId: `navbar-tab__${identity}-help_center`},
        },
    ]);

    return headerNavigationTabs;
}
